import { FC } from 'react';

import { useInitTracker } from '../../../feature-player/hooks/tracker/use-init-tracker';
import { usePlayerAnalytics } from '../../../feature-player/hooks/tracker/use-player-analytics';
import { getStreamsTrackingData } from '../../../feature-player/utils/get-streams-tracking-data';
import { useChannelCurrentStream } from '../../hooks/use-channel-current-stream';
import { useReadChannelPlayerBaseInfo } from '../../hooks/use-read-channel-player-base-info';

interface ChannelPlayerTrackerProps {
    contentId: string;
    psid: string;
}

export const ChannelPlayerTracker: FC<ChannelPlayerTrackerProps> = ({ contentId, psid }) => {
    const streamTrackingData = useChannelCurrentStream(contentId)?.streamMeta?.trackings;
    const isMultiplexChannel = useReadChannelPlayerBaseInfo(contentId)?.isMultiplex ?? false;

    useInitTracker({
        contentId,
        streamTrackingData: getStreamsTrackingData(streamTrackingData),
        additionalData: { isMultiplexChannel, isLive: 1 },
    });
    usePlayerAnalytics({
        contentId,
        psid,
        manifestUrl: useChannelCurrentStream(contentId)?.uri,
        viewStartedGtmEvent: 'TVCHANNELS_VIEW_STARTED',
    });

    return null;
};
